import { SET_PAYOUT_LIST } from "../actions/types";

const initialState = {
    payoutList: [],
    payoutListCount: 0
};
export default function (state = initialState, action) {
    const { type, payload, count } = action;
    switch (type) {
        case SET_PAYOUT_LIST:
            return {
                ...state,
                payoutList: payload,
                payoutListCount: count
            }
        default:
            return state;
    }
}
